export default __webpack_public_path__ + "static/media/icon_guide_password.f91f61c8.svg";